import type { Locales } from '@captaincause/types'

interface Props {
  dateString: string
  locale: Locales
}

interface TimeUnit {
  name: 'year' | 'month' | 'day'
  milliseconds: number
}

export function getTimeAgo({ dateString, locale }: Props) {
  const rtf = new Intl.RelativeTimeFormat(locale, { numeric: 'auto' })

  const units: TimeUnit[] = [
    { name: 'year', milliseconds: 1000 * 60 * 60 * 24 * 365 },
    { name: 'month', milliseconds: 1000 * 60 * 60 * 24 * 30 },
    { name: 'day', milliseconds: 1000 * 60 * 60 * 24 },
  ]

  const now = new Date()
  const date = new Date(dateString)
  const elapsed = Number(now) - Number(date)

  for (const unit of units) {
    const time = Math.floor(elapsed / unit.milliseconds)
    if (time >= 1) {
      return rtf.format(-time, unit.name)
    }
  }

  return rtf.format(-1, 'day')
}
